<template>
    <div class="relative" v-click-outside="hideDropdown">
        <biller-radio @click="click" :value="value + 'Other'" :active="active" class="relative">
            <div class="flex flex-col items-center w-full">
                <p class="text-grey-300 text-sm"><slot name="selected"></slot></p>
                <div class="flex items-center justify-center">
                    <div class="h-1 w-1 rounded-full bg-smoke-200 "></div>
                    <div class="h-1 w-1 rounded-full bg-smoke-200 mx-1"></div>
                    <div class="h-1 w-1 rounded-full bg-smoke-200 "></div>
                </div>
            </div>
        </biller-radio>
        <template v-if="showDropDown">
            <div class="rounded-lg bg-white py-5 absolute mt-3 z-30 dropdown">
                <div class="flex items-center justify-center px-6 mb-1">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M1.11132 4.44447C1.11132 2.6062 2.60626 1.11126 4.44452 1.11126C6.28278 1.11126 7.77773 2.6062 7.77773 4.44447C7.77773 6.28273 6.28278 7.77767 4.44452 7.77767C2.60626 7.77767 1.11132 6.28273 1.11132 4.44447ZM9.83684 9.05131L7.9508 7.16472C8.53578 6.41253 8.88854 5.46979 8.88854 4.44427C8.88854 1.99381 6.89473 0 4.44427 0C1.99381 0 0 1.99381 0 4.44427C0 6.89473 1.99381 8.88854 4.44427 8.88854C5.46979 8.88854 6.41253 8.53578 7.16472 7.9508L9.05131 9.83684C9.15964 9.94517 9.30186 9.99961 9.44408 9.99961C9.58629 9.99961 9.72851 9.94517 9.83684 9.83684C10.0541 9.61963 10.0541 9.26853 9.83684 9.05131Z"
                            fill="#D3DCE6"
                        />
                    </svg>
                    <input type="text" :placeholder="`Search ${text}`" v-model="search" class="text-xs ml-2" />
                </div>
                <ul class="h-48 overflow-auto">
                    <template v-if="mutableItem.length">
                        <li
                            class="flex py-3 items-center px-6 hover:bg-snow-300 duration-500 cursor-pointer"
                            v-for="(item, i) in items"
                            :key="item.value"
                            @click="selectItem(item, i)"
                        >
                            <!-- <img :src="require(`@/assets/${item.img}`)" alt="" class="mr-2 w-8" /> -->
                            <p class="text-grey-300 text-xs">{{ item.name || item.billername.split('-')[0] }}</p>
                        </li>
                    </template>
                    <template v-if="!mutableItem.length && search">
                        <li class="flex h-full w-10/12 text-center justify-center items-center mx-auto duration-500 ">
                            <!-- <img :src="require(`@/assets/${item.img}`)" alt="" class="mr-2 w-8" /> -->
                            <p class="text-grey-300 text-sm">
                                Sorry, <b>"{{ search }}"</b> is not found
                            </p>
                        </li>
                    </template>
                </ul>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
export default {
    props: {
        value: {
            type: String,
        },
        otherItems: {
            type: Array,
        },
        active: Boolean,
        text: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showDropDown: false,
            mutableItem: this.otherItems,
            search: '',
        }
    },
    computed: {
        items: function() {
            return this.mutableItem
        },
    },
    methods: {
        selectItem(item, i) {
            // if (i > 2 && this.search === '') {
            this.$emit('selectedItem', item)
            this.showDropDown = false
            // }
        },
        hideDropdown(event) {
            this.showDropDown = false
        },

        click() {
            this.showDropDown = true
            setTimeout(() => {
                this.showDropDown = true
            }, 500)
        },
    },

    updated() {
        this.otherItems.forEach((item) => {
            if (item.billername !== undefined) {
                item['name'] = item['billername']
                item.name = item.name.split('-')[0]
            }
        })
    },

    watch: {
        search: function(newValue) {
            this.mutableItem = this.otherItems.filter((val) => val.name.toLowerCase().includes(newValue))
        },
        otherItems: function(newValue) {
            this.$forceUpdate()
            this.mutableItem = newValue
        },
    },
}
</script>

<style scoped>
.dropdown {
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.05);
    width: 180px;
}
</style>
